import jQuery from 'jquery';

window.$ = jQuery; // workaround for https://github.com/parcel-bundler/parcel/issues/333

import instantsearch from 'instantsearch.js/es';
import {
  configure,
  searchBox,
  pagination,
  refinementList,
  hits,
  stats,
  sortBy,
  hierarchicalMenu,
  rangeSlider,
  numericMenu,
  ratingMenu,
  toggleRefinement,
  hitsPerPage,
  clearRefinements,
} from 'instantsearch.js/es/widgets';
import { history } from 'instantsearch.js/es/lib/routers';
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';

let TYPESENSE_SERVER_CONFIG = {
  apiKey: process.env.TYPESENSE_SEARCH_ONLY_API_KEY, // Be sure to use an API key that only allows searches, in production
  nodes: [
    {
      host: process.env.TYPESENSE_HOST,
      port: process.env.TYPESENSE_PORT,
      protocol: process.env.TYPESENSE_PROTOCOL,
    },
  ],
  useServerSideSearchCache: true,
  connectionTimeoutSeconds: 5,
  numRetries: 8,
};

// [2, 3].forEach(i => {
//   if (process.env[`TYPESENSE_HOST_${i}`]) {
//     TYPESENSE_SERVER_CONFIG.nodes.push({
//       host: process.env[`TYPESENSE_HOST_${i}`],
//       port: process.env.TYPESENSE_PORT,
//       protocol: process.env.TYPESENSE_PROTOCOL,
//     });
//   }
// });

// Unfortunately, dynamic process.env keys don't work with parcel.js
// So need to enumerate each key one by one

if (process.env[`TYPESENSE_HOST_2`]) {
  TYPESENSE_SERVER_CONFIG.nodes.push({
    host: process.env[`TYPESENSE_HOST_2`],
    port: process.env.TYPESENSE_PORT,
    protocol: process.env.TYPESENSE_PROTOCOL,
  });
}

if (process.env[`TYPESENSE_HOST_3`]) {
  TYPESENSE_SERVER_CONFIG.nodes.push({
    host: process.env[`TYPESENSE_HOST_3`],
    port: process.env.TYPESENSE_PORT,
    protocol: process.env.TYPESENSE_PROTOCOL,
  });
}

if (process.env[`TYPESENSE_HOST_NEAREST`]) {
  TYPESENSE_SERVER_CONFIG['nearestNode'] = {
    host: process.env[`TYPESENSE_HOST_NEAREST`],
    port: process.env.TYPESENSE_PORT,
    protocol: process.env.TYPESENSE_PROTOCOL,
  };
}

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: TYPESENSE_SERVER_CONFIG,
  additionalSearchParameters: {
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  queryBy is required.
    query_by: 'name,products,desc,brand_header,brand_details',
    sort_by: 'name:asc',
    query_by_weights: '4,5,3,2,1',
    num_typos: 1,
    typo_tokens_threshold: 1,
    exclude_fields: 'vectors',
    // By default, Typesense approximates facet counts for performance.
    // Turning on exhaustive search will get you accurate facet counts, at the cost of a slight performance hit.
    exhaustive_search: true,
    // group_by: "categories",
    // group_limit: 1
    // pinned_hits: "23:2"
  },
});
const searchClient = typesenseInstantsearchAdapter.searchClient;
const search = instantsearch({
  searchClient,
  indexName: 'manufacturers',
  routing: {
    router: history({ cleanUrlOnDispose: true }),
  },
  future: {
    preserveSharedStateOnUnmount: true,
  },
});

const basedInVal = [
  'Italy',
  'France',
  'Spain',
  'Portugal',
  'Turkey',
  'Germany',
  'Europe (general)',
  'Asia',
  'Other',
];

const priceRangeVal = [
  'Under €100',
  '€100–€300',
  '€300–€800',
  '€800–€2,000',
  '€2,000+',
];

// ============ Begin Widget Configuration
search.addWidgets([
  configure({
    hitsPerPage: 6, // Set custom default
  }),
  searchBox({
    container: '#searchbox',
    showSubmit: false,
    showReset: false,
    placeholder: 'Search brands... ',
    autofocus: false,
    cssClasses: {
      input:
        'bg-surface-container-low border-none rounded-lg pl-10 pr-4 py-2 w-64 focus:ring-2 focus:ring-primary/20 transition-all',
      loadingIcon: 'stroke-primary',
    },
  }),
  pagination({
    container: '#pagination',
    cssClasses: {
      list: 'flex items-center justify-center gap-1',
      item: 'flex items-center justify-center w-9 h-9 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 cursor-pointer transition-colors',
      link: 'flex items-center justify-center w-full h-full no-underline',
      disabledItem:
        'flex items-center justify-center w-9 h-9 text-gray-300 cursor-not-allowed pointer-events-none',
      selectedItem:
        'flex items-center justify-center w-9 h-9 rounded-lg bg-blue-700 text-white font-semibold text-sm shadow-md cursor-default',
      previousPageItem:
        'flex items-center justify-center w-9 h-9 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors',
      nextPageItem:
        'flex items-center justify-center w-9 h-9 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors',
    },
  }),
  // refinementList({
  //   limit: 10,
  //   showMoreLimit: 50,
  //   container: '#brand-list',
  //   attribute: 'name',
  //   searchable: false,
  //   searchablePlaceholder: 'Search brands',
  //   showMore: false,
  //   sortBy: ['name:asc'],
  //   cssClasses: {
  //     searchableInput:
  //       'form-control form-control-sm form-control-secondary mb-2 border-light-2',
  //     searchableSubmit: 'd-none',
  //     searchableReset: 'd-none',
  //     showMore: 'btn btn-secondary btn-sm',
  //     list: 'list-unstyled',
  //     count: 'badge text-dark-2 ms-2',
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  numericMenu({
    container: '#based_in',
    attribute: 'based_in',
    items: [
      { label: 'All' },
      { label: 'Italy', start: 0, end: 0 },
      { label: 'France', start: 1, end: 1 },
      { label: 'Spain', start: 2, end: 2 },
      { label: 'Portugal', start: 3, end: 3 },
      { label: 'Turkey', start: 4, end: 4 },
      { label: 'Germany', start: 5, end: 5 },
      { label: 'Europe (general)', start: 6, end: 6 },
      { label: 'Asia', start: 7, end: 7 },
      { label: 'Other', start: 8, end: 8 },
    ],
    cssClasses: {
      list: 'space-y-2',
      item: '',
      label: 'flex items-center gap-2 text-s cursor-pointer',
      radio: 'text-primary focus:ring-primary w-3.5 h-3.5',
    },
  }),
  // refinementList({
  //   limit: 10,
  //   showMoreLimit: 50,
  //   container: '#based-in-list',
  //   attribute: 'based_in',
  //   searchable: false,
  //   searchablePlaceholder: 'Search country of origin',
  //   showMore: false,
  //   sortBy: ['based_in:asc'],
  //   cssClasses: {
  //     searchableInput:
  //       'form-control form-control-sm form-control-secondary mb-2 border-light-2',
  //     searchableSubmit: 'd-none',
  //     searchableReset: 'd-none',
  //     showMore: 'btn btn-secondary btn-sm',
  //     list: 'list-unstyled',
  //     count: 'badge text-dark-2 ms-2',
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  rangeSlider({
    container: '#slider-moq_value',
    attribute: 'moq_value',
    step: 500,
    pips: false,
    tooltips: {
      format: (value) => `€${value}`, // Formats the handles
    },
    cssClasses: {
      target: 'relative h-2 rounded-full bg-surface',
      base: 'size-full relative z-1',
      origin: 'absolute top-0 end-0 size-full origin-[0_0] rounded-full',
      handle:
        'absolute top-1/2 end-0 size-4.5 bg-layer border-4 border-primary rounded-full cursor-pointer translate-x-2/4 -translate-y-2/4',
      connects: 'relative z-0 size-full rounded-full overflow-hidden',
      connect: 'absolute top-0 end-0 z-1 size-full origin-[0_0] bg-primary',
      touchArea: 'absolute -inset-1',
    },
  }),
  rangeSlider({
    container: '#slider-moq_units',
    attribute: 'moq_units',
    min: 0,
    max: 100,
    step: 5,
    pips: false,
    cssClasses: {
      target: 'relative h-2 rounded-full bg-surface',
      base: 'size-full relative z-1',
      origin: 'absolute top-0 end-0 size-full origin-[0_0] rounded-full',
      handle:
        'absolute top-1/2 end-0 size-4.5 bg-layer border-4 border-primary rounded-full cursor-pointer translate-x-2/4 -translate-y-2/4',
      connects: 'relative z-0 size-full rounded-full overflow-hidden',
      connect: 'absolute top-0 end-0 z-1 size-full origin-[0_0] bg-primary',
      touchArea: 'absolute -inset-1',
    },
  }),
  rangeSlider({
    container: '#slider-moq_weight',
    attribute: 'moq_weight',
    step: 50,
    pips: false,
    tooltips: {
      format: (value) => `${value}g`, // Formats the handles
    },
    cssClasses: {
      target: 'relative h-2 rounded-full bg-surface',
      base: 'size-full relative z-1',
      origin: 'absolute top-0 end-0 size-full origin-[0_0] rounded-full',
      handle:
        'absolute top-1/2 end-0 size-4.5 bg-layer border-4 border-primary rounded-full cursor-pointer translate-x-2/4 -translate-y-2/4',
      connects: 'relative z-0 size-full rounded-full overflow-hidden',
      connect: 'absolute top-0 end-0 z-1 size-full origin-[0_0] bg-primary',
      touchArea: 'absolute -inset-1',
    },
  }),
  // hierarchicalMenu({
  //   container: '#categories-hierarchical-menu',
  //   showParentLevel: true,
  //   rootPath: 'Cell Phones',
  //   attributes: ['moq_value', 'moq_units', 'moq_weight', 'lead_time'],
  //   cssClasses: {
  //     showMore: 'btn btn-secondary btn-sm',
  //     list: 'list-unstyled',
  //     childList: 'ms-4',
  //     count: 'badge text-dark-2 ms-2',
  //     link: 'text-dark text-decoration-none',
  //     selectedItem: 'text-primary fw-bold',
  //     parentItem: 'text-dark fw-bold',
  //   },
  // }),

  refinementList({
    container: '#toggle-currmkt',
    attribute: 'currmkt',
    searchable: false,
    searchablePlaceholder: 'Search brands',
    showMore: false,
    sortBy: ['currmkt:asc'],
    cssClasses: {
      searchableInput:
        'form-control form-control-sm form-control-secondary mb-2 border-light-2',
      searchableSubmit: 'd-none',
      searchableReset: 'd-none',
      showMore: 'btn btn-secondary btn-sm',
      list: 'list-unstyled',
      count: 'badge text-dark-2 ms-2',
      label: 'd-flex align-items-center',
      checkbox: 'me-2',
    },
  }),

  // toggleRefinement({
  //   container: '#toggle-currmkt_global',
  //   attribute: 'currmkt_global',
  //   templates: {
  //     labelText: () => 'Global',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-currmkt_europe',
  //   attribute: 'currmkt_europe',
  //   templates: {
  //     labelText: () => 'Europe',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-currmkt_n_america',
  //   attribute: 'currmkt_n_america',
  //   templates: {
  //     labelText: () => 'North America',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-currmkt_s_america',
  //   attribute: 'currmkt_s_america',
  //   templates: {
  //     labelText: () => 'South America',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-currmkt_mena',
  //   attribute: 'currmkt_mena',
  //   templates: {
  //     labelText: () => 'Middle East (MENA)',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-currmkt_east_asia',
  //   attribute: 'currmkt_east_asia',
  //   templates: {
  //     labelText: () => 'East Asia',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-currmkt_local',
  //   attribute: 'currmkt_local',
  //   templates: {
  //     labelText: () => 'Limited / Local only',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  refinementList({
    container: '#toggle-materials',
    attribute: 'materials',
    searchable: false,
    searchablePlaceholder: 'Search brands',
    showMore: false,
    sortBy: ['materials:asc'],
    cssClasses: {
      searchableInput:
        'form-control form-control-sm form-control-secondary mb-2 border-light-2',
      searchableSubmit: 'd-none',
      searchableReset: 'd-none',
      showMore: 'btn btn-secondary btn-sm',
      list: 'list-unstyled',
      count: 'badge text-dark-2 ms-2',
      label: 'd-flex align-items-center',
      checkbox: 'me-2',
    },
  }),

  // toggleRefinement({
  //   container: '#toggle-mat_gold18k',
  //   attribute: 'mat_gold18k',
  //   templates: {
  //     labelText: () => '18K gold',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-mat_gold14k',
  //   attribute: 'mat_gold14k',
  //   templates: {
  //     labelText: () => '14K gold',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-mat_gold9k',
  //   attribute: 'mat_gold9k',
  //   templates: {
  //     labelText: () => '9K gold',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-mat_sterling',
  //   attribute: 'mat_sterling',
  //   templates: {
  //     labelText: () => 'Sterling silver',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-mat_goldplated',
  //   attribute: 'mat_goldplated',
  //   templates: {
  //     labelText: () => 'Gold-plated',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-mat_brass',
  //   attribute: 'mat_brass',
  //   templates: {
  //     labelText: () => 'Brass',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-mat_enamel',
  //   attribute: 'mat_enamel',
  //   templates: {
  //     labelText: () => 'Enamel',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-mat_stone',
  //   attribute: 'mat_stone',
  //   templates: {
  //     labelText: () => 'Precious Stones',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-mat_pearl',
  //   attribute: 'mat_pearl',
  //   templates: {
  //     labelText: () => 'Pearl',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-mat_diamond',
  //   attribute: 'mat_diamond',
  //   templates: {
  //     labelText: () => 'Diamond',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  rangeSlider({
    container: '#slider-lead_time',
    attribute: 'lead_time',
    min: 1,
    max: 8,
    step: 1,
    pips: false,
    cssClasses: {
      target: 'relative h-2 rounded-full bg-surface',
      base: 'size-full relative z-1',
      origin: 'absolute top-0 end-0 size-full origin-[0_0] rounded-full',
      handle:
        'absolute top-1/2 end-0 size-4.5 bg-layer border-4 border-primary rounded-full cursor-pointer translate-x-2/4 -translate-y-2/4',
      connects: 'relative z-0 size-full rounded-full overflow-hidden',
      connect: 'absolute top-0 end-0 z-1 size-full origin-[0_0] bg-primary',
      touchArea: 'absolute -inset-1',
    },
  }),
  numericMenu({
    container: '#payment_terms',
    attribute: 'payment_terms',
    items: [
      { label: 'All' },
      { label: '100% upfront', start: 0, end: 0 },
      { label: '50% upfront / 50% before delivery', start: 1, end: 1 },
      { label: '30% deposit / balance before delivery', start: 2, end: 2 },
      { label: 'Net terms (e.g. 30 days)', start: 3, end: 3 },
      { label: 'Case-by-case / negotiable', start: 4, end: 4 },
      { label: '8 days (pro forma)', start: 5, end: 5 },
    ],
    cssClasses: {
      list: 'space-y-2',
      item: '',
      label: 'flex items-center gap-2 text-s cursor-pointer',
      radio: 'text-primary focus:ring-primary w-3.5 h-3.5',
    },
  }),
  numericMenu({
    container: '#price_range',
    attribute: 'price_range',
    items: [
      { label: 'All' },
      { label: 'Under €100', start: 0, end: 0 },
      { label: '€100–€300', start: 1, end: 1 },
      { label: '€300–€800', start: 2, end: 2 },
      { label: '€800–€2,000', start: 3, end: 3 },
      { label: '€2,000+', start: 4, end: 4 },
    ],
    cssClasses: {
      list: 'space-y-2',
      item: '',
      label: 'flex items-center gap-2 text-s cursor-pointer',
      radio: 'text-primary focus:ring-primary w-3.5 h-3.5',
    },
  }),
  // toggleRefinement({
  //   container: '#price_range_0',
  //   attribute: 'price_range',
  //   on: 0,
  //   templates: {
  //     labelText: () => 'Under €100',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#price_range_1',
  //   attribute: 'price_range',
  //   on: 1,
  //   templates: {
  //     labelText: () => '€100–€300',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#price_range_2',
  //   attribute: 'price_range',
  //   on: 2,
  //   templates: {
  //     labelText: () => '€300–€800',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#price_range_3',
  //   attribute: 'price_range',
  //   on: 3,
  //   templates: {
  //     labelText: () => '€800–€2,000',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#price_range_4',
  //   attribute: 'price_range',
  //   on: 4,
  //   templates: {
  //     labelText: () => '€2,000+',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // numericMenu({
  //   container: '#platform_openness',
  //   attribute: 'platform_openness',
  //   items: [
  //     { label: 'All' },
  //     { label: 'Highly likely', start: 0, end: 0 },
  //     { label: 'Somewhat likely', start: 1, end: 1 },
  //     { label: 'Neutral', start: 2, end: 2 },
  //     { label: 'Unlikely', start: 3, end: 3 },
  //     { label: 'Highly unlikely', start: 4, end: 4 },
  //   ],
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     radio: 'me-2',
  //     list: 'list-unstyled',
  //   },
  // }),
  refinementList({
    container: '#toggle-prodtypes',
    attribute: 'prodtypes',
    searchable: false,
    searchablePlaceholder: 'Search brands',
    showMore: false,
    sortBy: ['prodtypes:asc'],
    cssClasses: {
      searchableInput:
        'form-control form-control-sm form-control-secondary mb-2 border-light-2',
      searchableSubmit: 'd-none',
      searchableReset: 'd-none',
      showMore: 'btn btn-secondary btn-sm',
      list: 'list-unstyled',
      count: 'badge text-dark-2 ms-2',
      label: 'd-flex align-items-center',
      checkbox: 'me-2',
    },
  }),

  // toggleRefinement({
  //   container: '#toggle-prodtype_bracelet',
  //   attribute: 'prodtype_bracelet',
  //   templates: {
  //     labelText: () => 'Bracelets',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-prodtype_necklace',
  //   attribute: 'prodtype_necklace',
  //   templates: {
  //     labelText: () => 'Necklaces',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-prodtype_earring',
  //   attribute: 'prodtype_earring',
  //   templates: {
  //     labelText: () => 'Earrings',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-prodtype_ring',
  //   attribute: 'prodtype_ring',
  //   templates: {
  //     labelText: () => 'Rings',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#toggle-prodtype_charm',
  //   attribute: 'prodtype_charm',
  //   templates: {
  //     labelText: () => 'Charms',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  numericMenu({
    container: '#years_in_business',
    attribute: 'years_in_business',
    items: [
      { label: 'All' },
      { label: '0–5 years', start: 0, end: 5 },
      { label: '5–10 years', start: 5, end: 10 },
      { label: '10–20 years', start: 10, end: 20 },
      { label: '20+ years', start: 20, end: 2000 },
    ],
    cssClasses: {
      list: 'space-y-2',
      item: '',
      label: 'flex items-center gap-2 text-s cursor-pointer',
      radio: 'text-primary focus:ring-primary w-3.5 h-3.5',
    },
  }),
  numericMenu({
    container: '#shipping_origin',
    attribute: 'shipping_origin',
    items: [
      { label: 'All' },
      { label: 'Italy', start: 0, end: 0 },
      { label: 'France', start: 1, end: 1 },
      { label: 'Spain', start: 2, end: 2 },
      { label: 'Portugal', start: 3, end: 3 },
      { label: 'Turkey', start: 4, end: 4 },
      { label: 'Germany', start: 5, end: 5 },
      { label: 'Europe (general)', start: 6, end: 6 },
      { label: 'Asia', start: 7, end: 7 },
      { label: 'Other', start: 8, end: 8 },
    ],
    cssClasses: {
      list: 'space-y-2',
      item: '',
      label: 'flex items-center gap-2 text-s cursor-pointer',
      radio: 'text-primary focus:ring-primary w-3.5 h-3.5',
    },
  }),
  refinementList({
    container: '#other_options',
    attribute: 'other_options',
    searchable: false,
    searchablePlaceholder: 'Search brands',
    showMore: false,
    sortBy: ['other_options:asc'],
    cssClasses: {
      searchableInput:
        'form-control form-control-sm form-control-secondary mb-2 border-light-2',
      searchableSubmit: 'd-none',
      searchableReset: 'd-none',
      showMore: 'btn btn-secondary btn-sm',
      list: 'list-unstyled',
      count: 'badge text-dark-2 ms-2',
      label: 'd-flex align-items-center',
      checkbox: 'me-2',
    },
  }),

  // toggleRefinement({
  //   container: '#sample_available',
  //   attribute: 'sample_available',
  //   templates: {
  //     labelText: () => 'Sample Available',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#packaging_provided',
  //   attribute: 'packaging_provided',
  //   templates: {
  //     labelText: () => 'Packaging Provided',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#display_materials',
  //   attribute: 'display_materials',
  //   templates: {
  //     labelText: () => 'Display Materials',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),
  // toggleRefinement({
  //   container: '#oem_capability',
  //   attribute: 'oem_capability',
  //   templates: {
  //     labelText: () => 'OEM capability',
  //   },
  //   cssClasses: {
  //     label: 'd-flex align-items-center',
  //     checkbox: 'me-2',
  //   },
  // }),

  // ratingMenu({
  //   container: '#rating-menu',
  //   attribute: 'rating',
  //   cssClasses: {
  //     list: 'list-unstyled',
  //     link: 'text-decoration-none',
  //     starIcon: '',
  //     count: 'badge text-dark-2 ms-2',
  //     disabledItem: 'text-muted',
  //     selectedItem: 'fw-bold text-primary',
  //   },
  // }),
  sortBy({
    container: '#sort-by',
    items: [
      { label: 'Relevance', value: 'manufacturers' },
      { label: 'Brand (asc)', value: 'manufacturers/sort/name:asc' },
      { label: 'Brand (desc)', value: 'manufacturers/sort/name:desc' },
      { label: 'MOQ Value (asc)', value: 'manufacturers/sort/moq_value:asc' },
      { label: 'MOQ Value (desc)', value: 'manufacturers/sort/moq_value:desc' },
      { label: 'Lead Time (asc)', value: 'manufacturers/sort/lead_time:asc' },
      { label: 'Lead Time (desc)', value: 'manufacturers/sort/lead_time:desc' },
    ],
    cssClasses: {
      select:
        'bg-transparent border-none text-sm font-bold text-primary focus:ring-0 cursor-pointer',
    },
  }),
  hits({
    container: '#hits',
    templates: {
      empty:
        '<div class="text-lg font-medium text-slate-500 h-[5rem]">No matches found.</div>',
      item: (hit, { html, components }) => html`
        <div class="group flex flex-col h-full transition-all duration-300">
          <div
            class="relative mb-6 aspect-[1] overflow-hidden bg-surface-container-low rounded-lg"
          >
            <img
              alt="Product"
              class="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100"
              data-alt="${hit.name}"
              src="${hit.logo_url}"
            />
            <div class=".fghf absolute flex flex-wrap gap-2 left-4 top-4">
              <span
                class="bg-surface-container-high text-on-surface text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest"
                >${hit.tags[0]}</span
              >
            </div>
          </div>
          <div class="flex-grow space-y-2">
            <div class="grid grid-cols-[75%_25%] justify-between items-start">
              <h3
                class="flex items-end h-full text-lg font-bold text-on-surface leading-tight group-hover:text-primary transition-colors line-clamp-2 overflow-hidden"
              >
                ${components.Highlight({ hit, attribute: 'name' })}
              </h3>
              <div class="text-right self-start">
                <span
                  class="bg-secondary-container text-on-secondary-container px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider"
                  >${basedInVal[hit.based_in]}</span
                >
              </div>
            </div>
            <p class="text-md font-medium text-slate-500 h-[5rem]">
              ${components.Highlight({
                hit,
                attribute: 'desc',
              })}
            </p>
            <div class="flex flex-col items-start justify-start">
              <p class="text-md font-medium text-slate-500 h-[1.5rem]">
                ${priceRangeVal[hit.price_range]}
              </p>

              <p class="text-md font-medium text-slate-500 h-[1.5rem]">
                <strong>Minimum order (MOQ): </strong>
                ${[
                  hit.moq_value && hit.moq_value !== 0
                    ? `€${hit.moq_value}`
                    : null,
                  hit.moq_units && hit.moq_units !== 0
                    ? `${hit.moq_units} units`
                    : null,
                  hit.moq_weight && hit.moq_weight !== 0
                    ? `${hit.moq_weight}g`
                    : null,
                ]
                  .filter(Boolean)
                  .join(' / ') || 'Flexible'}
              </p>
              <p class="text-md font-medium text-slate-500 h-[1.5rem]">
                <strong>Lead time:</strong> ${hit.lead_time == 1
                  ? `${hit.lead_time} week`
                  : `${hit.lead_time} weeks`}
              </p>
            </div>
            <div
              class="pt-4 flex items-center justify-between border-t border-surface-container-high mt-4"
            >
              <a href="/mfg-profile?id=${hit.id}">
                <button
                  class="bg-primary-container text-white px-4 py-2 text-xs font-bold rounded-md hover:bg-primary transition-all duration-200"
                >
                  View Brand
                </button>
              </a>
            </div>
          </div>
        </div>
      `,
    },
    cssClasses: {
      list: 'gap-x-8 gap-y-12 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3',
      item: 'ais-Hits-item d-flex flex-column search-result-card',
      loadMore: 'btn btn-primary mx-auto d-block mt-4',
      disabledLoadMore: 'btn btn-dark mx-auto d-block mt-4',
    },
  }),
  // hitsPerPage({
  //   container: '#hits-per-page',
  //   items: [
  //     { label: '9 per page', value: 9, default: true },
  //     { label: '18 per page', value: 18 },
  //   ],
  //   cssClasses: {
  //     select: 'form-select form-select-sm border-none text-black',
  //   },
  // }),
  stats({
    container: '#stats',
    templates: {
      text: (
        { nbHits, hasNoResults, hasOneResult, processingTimeMS },
        { html }
      ) => {
        let statsText = '';
        if (hasNoResults) {
          statsText = 'no results';
          return html`<div>
            No brands were found that match your criteria.
          </div>`;
        } else if (hasOneResult) {
          // statsText = '1 manufacturer';
          return html`Brand matched to your criteria.`;
        } else {
          statsText = `${nbHits.toLocaleString()} jewelry brands`;
          return html`${statsText} matched to your criteria.`;
        }
      },
    },
    cssClasses: {
      text: 'text-slate-500 max-w-md',
    },
  }),
  clearRefinements({
    container: '#clear-refinements',
    templates: {
      resetLabel: 'Start new search',
    },
    cssClasses: {
      button:
        'w-full bg-[#ccdf00]/20 hover:bg-[#ccdf00]/40 text-[#6a7300] font-bold py-2 px-4 rounded text-xs transition-colors mt-8',
    },
  }),
]);

// window.sendEventDebounced = debounce((uiState) => {
//   window.gtag('event', 'page_view', {
//     page_path: window.location.pathname + window.location.search,
//   });
// }, 500);

// search.use(() => ({
//   onStateChange({ uiState }) {
//     window.sendEventDebounced(uiState);
//   },
//   subscribe() {},
//   unsubscribe() {},
// }));

search.start();